import { Source, SourceWeight } from './source';
import { Transformation, IndicatorType, ScoreFilteringType } from './transformation';
import { Destination, DestinationType } from './destination';

export enum WorkflowType {
  INDICATOR_PRIORITIZATION = 'INDICATOR_PRIORITIZATION',
  BLANK = 'BLANK', // Only used for empty workflows,
}

export enum WorkflowStatus {
  UP = 'UP',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  DISABLED = 'DISABLED',
}

export type Workflow = {
  guid?: string,
  name: string,
  type: WorkflowType,
  sources: Source[],
  transformations: Transformation,
  destination: Destination,
  createdAt?: number,
  updatedAt?: number,
  // Optional until back-end supports it.
  status?: WorkflowStatus,
  safelistGuids?: string[],
  // UI-related property.
  isNew?: boolean,
};

export type BlankWorkflow = {
  guid?: string,
  name: string,
  type: WorkflowType,
  sources: Source[],
  transformations: Transformation,
  destination: Destination,
  createdAt?: number,
  updatedAt?: number,
  // Optional until back-end supports it.
  status?: WorkflowStatus,
  isEmpty: boolean,
}
/**
 * Represents a workflow object without being parsed (exactly as sent by back-end).
 */
export type RawWorkflow = {
  guid: string,
  name: string,
  created: number,
  updated: number,
  safelistGuids: string[],
  workflowConfig: {
    type: WorkflowType,
    workflowSource: {
      enclaveSourceConfig: Array<{
        enclaveGuid: string,
        weight: SourceWeight,
      }>,
    },
    observableTypes: IndicatorType[],
    priorityScores: ScoreFilteringType[],
    workflowDestination: {
      enclaveDestinationConfigs: Array<{
        enclaveGuid: string,
        enclaveName: string,
        destinationType: DestinationType,
        workflowUserGuid: string,
      }>,
    },
  },
};

export type CreateDestinationConfigEnclaveType = {
  destinationType: DestinationType,
}

export type UpdateDestinationConfigEnclaveType = {
  enclaveGuid: string,
  enclaveName: string,
}
